import React from "react";
import { DatePicker } from "../../index";
export default (props) => {
  const opts = props.opts || {};
  opts.showTime = true;
  opts.format = "YYYY-MM-DD HH:mm";
  return <DatePicker {...props} opts={opts} />;
};
